"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var emphasis = ui_blocks_1.TYPOGRAPHY.emphasis;
exports.Input = styled_components_1.default.input(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n  width: 100%;\n  height: 100%;\n  appearance: textfield;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  color: ", ";\n  line-height: revert;\n  caret-color: ", ";\n  text-align: ", ";\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    appearance: none;\n    margin: 0;\n  }\n\n  &:focus {\n    border: none;\n    outline: none;\n    box-shadow: none;\n  }\n"], ["\n  ", "\n  width: 100%;\n  height: 100%;\n  appearance: textfield;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  color: ", ";\n  line-height: revert;\n  caret-color: ", ";\n  text-align: ", ";\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    appearance: none;\n    margin: 0;\n  }\n\n  &:focus {\n    border: none;\n    outline: none;\n    box-shadow: none;\n  }\n"])), emphasis, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.DARK', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
}, function (_a) {
  var hasSpinButton = _a.hasSpinButton;
  return hasSpinButton ? 'left' : 'center';
});
var templateObject_1;